import { render, staticRenderFns } from "./VExploreNewProjects.vue?vue&type=template&id=f55f0f7c&"
import script from "./VExploreNewProjects.vue?vue&type=script&lang=js&"
export * from "./VExploreNewProjects.vue?vue&type=script&lang=js&"
import style0 from "./VExploreNewProjects.vue?vue&type=style&index=0&id=f55f0f7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports